/**
 * Private modules
 */
const {
  createQueryComponent,
  customerId,
  objectId,
  objectIds,
  systemGameCategoryIds,
  systemGameId,
} = require('../.private').components;

/**
 * Scopes
 */
const {
  CUSTOMER_RUNNER_TICKET_SCHEMES_ARCHIVED_BY_SYSTEM_GAME_ID,
  CUSTOMER_RUNNER_TICKET_SCHEMES_INPUT_BY_SYSTEM_GAME_ID,
  DEFAULT,
} = require('../../scopes');

/**
 * Constant variables
 */
const alias = {
  default: null,
  type: [
    'null',
    'string',
  ],
};
module.exports = {
  archiveCustomerRunnerTicketSchemesBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  copyCustomerRunnerTicketSchemesBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  createCustomerRunnerTicketSchemeBySystemGameId: {
    properties: {
      body: {
        properties: {
          alias,
          systemGameCategoryIds,
        },
        required: [
          'alias',
          'systemGameCategoryIds',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  deleteCustomerRunnerTicketSchemesBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getCustomerRunnerTicketSchemesBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
      query: createQueryComponent([
        CUSTOMER_RUNNER_TICKET_SCHEMES_ARCHIVED_BY_SYSTEM_GAME_ID,
        CUSTOMER_RUNNER_TICKET_SCHEMES_INPUT_BY_SYSTEM_GAME_ID,
        DEFAULT,
      ]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  reorderCustomerRunnerTicketSchemesBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  unarchiveCustomerRunnerTicketSchemesBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  updateCustomerRunnerTicketSchemeById: {
    properties: {
      body: {
        properties: {
          alias,
        },
        required: ['alias'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          objectId,
        },
        required: [
          'customerId',
          'objectId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
